import styled from '@emotion/styled';
import { RawHtml, Text, TextProps } from '~/shared/components';
import Flex from '~/shared/components/Flex';
import { breakpoints } from '~/theme/breakpoints';
import { Grid } from '~/shared/components/Grid/Grid';

type Price = 'discount' | 'default';

export const DataContainer = styled.div(({ theme }) => ({
    marginBottom: theme.space[3],
}));

export const Header = styled((props: TextProps) => (
    <Text variant="InfoHeader" as="h1" {...props} />
))(({ theme }) => ({
    position: 'relative',
    marginBottom: theme.space[2],
}));

export const HeaderText = styled(RawHtml)(({ theme }) => ({
    color: theme.colors.black,
    '> p': {
        ...theme.mixins.useTextStyle('bodySmall'),
    },
}));

export const DataHeader = styled((props: TextProps) => (
    <Text variant="InfoHeader" as="h3" {...props} />
))(({ theme }) => ({
    marginBottom: theme.space[1],
}));

export const DataHeaderCaption = styled((props: TextProps) => <DataHeader {...props} />)(
    ({ theme }) => ({
        color: theme.colors.grey100,
    }),
);

export const DataText = styled((props: TextProps) => <Text variant="bodySmall" {...props} />)();

export const DotSeparator = styled((props: TextProps) => <DataHeader {...props} />)(() => ({
    '::after': {
        content: '" · "',
        whiteSpace: 'pre',
    },
}));

export const SummeryWrapper = styled.div(({ theme }) => ({
    border: `1px solid ${theme.colors.grey35}`,
}));

export const PriceList = styled.ul(({ theme }) => ({
    border: `1px solid ${theme.colors.grey35}`,
    borderTop: 'none',
    padding: theme.space[2],
}));

export const PriceItem = styled.li<{ type?: Price }>(({ theme, type }) => ({
    display: 'flex',
    flexDirection: 'row',
    padding: theme.space[2],
    color: type === 'discount' ? theme.colors.redMediumLight : theme.colors.black,
    p: {
        flex: '0 auto',
    },
    'p:first-child': {
        flex: 1,
    },
}));

export const Details = styled(Flex)({
    flex: 1,
    padding: '10px',
    [breakpoints.xs]: {
        padding: '0px 10px 0 0',
        flexDirection: 'column',
        alignSelf: 'center',
    },
});

export const StyledGrid = styled(Grid)({
    [breakpoints.xs]: {
        gridAutoFlow: 'row',
        gridTemplateRows: '1fr',
    },
    [breakpoints.sm]: {
        gridAutoFlow: 'column',
        gridTemplateColumns: '2fr 1fr',
    },
});
